export enum IcpIntelChartTypeEnum {
  REVENUE_RANGE = 'REVENUE_RANGE',
  SIZE_RANGE = 'SIZE_RANGE',
  DEPARTMENT_SIZE_MARKETING = 'DEPARTMENT_SIZE_MARKETING',
  DEPARTMENT_SIZE_OPERATIONS = 'DEPARTMENT_SIZE_OPERATIONS',
  DEPARTMENT_SIZE_PROCUREMENT = 'DEPARTMENT_SIZE_PROCUREMENT',
  DEPARTMENT_SIZE_LEGAL = 'DEPARTMENT_SIZE_LEGAL',
  DEPARTMENT_SIZE_RND = 'DEPARTMENT_SIZE_RND',
  DEPARTMENT_SIZE_HR = 'DEPARTMENT_SIZE_HR',
  DEPARTMENT_SIZE_IT = 'DEPARTMENT_SIZE_IT',
  DEPARTMENT_SIZE_SALES = 'DEPARTMENT_SIZE_SALES',
  DEPARTMENT_SIZE_FINANCE = 'DEPARTMENT_SIZE_FINANCE',
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  PRODUCT = 'PRODUCT',
  SPECIALTY = 'SPECIALTY',
  FAVORITE = 'FAVORITE',
  INDUSTRY = 'INDUSTRY',
  SECTOR = 'SECTOR',
}

export namespace IcpIntelChartTypeEnum {
  export function getDepartmentList(): IcpIntelChartTypeEnum[] {
    return [
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_MARKETING,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_OPERATIONS,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_PROCUREMENT,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_LEGAL,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_RND,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_HR,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_IT,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_SALES,
      IcpIntelChartTypeEnum.DEPARTMENT_SIZE_FINANCE,
    ];
  }
}
